import { MSG_TAREFA_INCOMPATIVEL } from '../messages';

const INITIAL_STATE = {
  alerta: {},
  alertaProcuradores: {},
  esperandoSolicitacao: false,
  esperandoSolicitacaoQtd: 0,
  esperandoExigencia: false,
  cpfCnpjProcurador: "",
  nomeProcurador: "",
  erro: null,
  tarefa: null,
  comentario: null,
  agendamento: null,
  agendamentos: [],
  camposExigencia: [],
  refreshTarefa: 0,
  fragmento: null,
  permissaoRealizarAnaliseDocumental: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'REQUERIMENTO_DETALHAR_TAREFA_CONSULTAR_INICIAR':
      return { ...state, esperandoSolicitacao: true, esperandoSolicitacaoQtd: state.esperandoSolicitacaoQtd + 1, esperandoSolicitacaoQtd: state.esperandoSolicitacaoQtd + 1 }
    case 'REQUERIMENTO_DETALHAR_TAREFA_CONSULTAR_SUCESSO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), alerta: {}, tarefa: action.payload }
    case 'REQUERIMENTO_DETALHAR_TAREFA_CONSULTAR_SUCESSO_INCOMPATIVEL':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), tarefa: action.payload, alerta: { message: MSG_TAREFA_INCOMPATIVEL, severity: 'error' } }
    case 'REQUERIMENTO_DETALHAR_TAREFA_CONSULTAR_ERRO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), erro: action.payload }
    case 'REQUERIMENTO_DETALHAR_CLOSE_MESSAGE':
      return { ...state, alerta: {}, alertaProcuradores: {} }
    case 'REQUERIMENTO_DETALHAR_HANDLE_ATRIBUTO_PROCURADOR': {
      let { atributo, valor } = action.payload;
      if (atributo === 'cpfCnpjProcurador') {
        return { ...state, cpfCnpjProcurador: valor }
      } else if (atributo === 'nomeProcurador') {
        return { ...state, nomeProcurador: valor }
      }
      break;
    }
    case 'REQUERIMENTO_DETALHAR_INICIAR_INCLUIR_PROCURADOR':
      return { ...state, esperandoSolicitacao: true, esperandoSolicitacaoQtd: state.esperandoSolicitacaoQtd + 1, alertaProcuradores: {} }
    case 'REQUERIMENTO_DETALHAR_INCLUIR_PROCURADOR_SUCESSO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), cpfCnpjProcurador: '', nomeProcurador: '' }
    case 'REQUERIMENTO_DETALHAR_INCLUIR_PROCURADOR_ERRO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), alertaProcuradores: { message: action.payload, severity: 'error' } }
    case 'REQUERIMENTO_DETALHAR_INICIAR_REMOVER_PROCURADOR':
      return { ...state, esperandoSolicitacao: true, esperandoSolicitacaoQtd: state.esperandoSolicitacaoQtd + 1, alertaProcuradores: {} }
    case 'REQUERIMENTO_DETALHAR_REMOVER_PROCURADOR_SUCESSO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0) }
    case 'REQUERIMENTO_DETALHAR_REMOVER_PROCURADOR_ERRO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), alertaProcuradores: { message: action.payload, severity: 'error' } }
    case 'REQUERIMENTO_DETALHAR_SHOW_SUCCESS_MESSAGE':
      return { ...state, alerta: { message: action.payload, severity: "success" } };
    case 'REQUERIMENTO_DETALHAR_EXIBIR_ALERTA':
      return { ...state, alerta: action.payload, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0) }
    case 'REQUERIMENTO_DETALHAR_DESPACHO_CONSULTAR_SUCESSO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), comentario: action.payload }
    case 'REQUERIMENTO_DETALHAR_AGENDAMENTOS_CONSULTAR_INICIAR':
      return { ...state, esperandoSolicitacao: true, esperandoSolicitacaoQtd: state.esperandoSolicitacaoQtd + 1, alerta: {} }
    case 'REQUERIMENTO_DETALHAR_AGENDAMENTOS_CONSULTAR_SUCESSO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), alerta: {}, agendamentos: action.payload }
    case 'REQUERIMENTO_DETALHAR_AGENDAMENTOS_CONSULTAR_ERRO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), alerta: { message: action.payload, severity: 'error' } }
    case 'REQUERIMENTO_DETALHAR_AGENDAMENTO_POR_ID_INICIAR':
      return { ...state, esperandoSolicitacao: true, esperandoSolicitacaoQtd: state.esperandoSolicitacaoQtd + 1 }
    case 'REQUERIMENTO_DETALHAR_AGENDAMENTO_POR_ID_SUCESSO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), agendamento: action.payload }
    case 'REQUERIMENTO_DETALHAR_AGENDAMENTO_POR_ID_ERRO':
    case 'REQUERIMENTO_DADOS_PEDIDO_VALIDAR_TAREFA_INCOMPATIVEL_ERROR':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), esperandoExigencia: false, alerta: { message: action.payload, severity: 'error' } }
    case 'REQUERIMENTO_EXIGENCIA_INCLUIR_COMENTARIO':
      return { ...state, esperandoSolicitacao: true, esperandoSolicitacaoQtd: state.esperandoSolicitacaoQtd + 1, esperandoExigencia: true }
    case 'REQUERIMENTO_EXIGENCIA_COMENTARIO_SUCESSO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), esperandoExigencia: false }
    case 'REQUERIMENTO_EXIGENCIA_COMENTARIO_ERRO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), esperandoExigencia: false, alerta: { message: action.payload, severity: 'error' } }
    case 'REQUERIMENTO_DETALHAR_CAMPOS_ADICIONAIS_SERVICO_POR_ID_INICIAR':
      return { ...state, esperandoSolicitacao: true, esperandoSolicitacaoQtd: state.esperandoSolicitacaoQtd + 1, alerta: {} }
    case 'REQUERIMENTO_DETALHAR_SERVICO_POR_ID_SUCESSO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), alerta: {}, tarefa: { ...state.tarefa, servico: action.payload } }
    case 'REQUERIMENTO_DETALHAR_CAMPOS_ADICIONAIS_SERVICO_POR_ID_SUCESSO':
      return {
        ...state,
        esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0),
        alerta: {},
        tarefa: {
          ...state.tarefa,
          servico: {
            ...state.tarefa.servico,
            camposAdicionais: action.payload
          }
        }
      }
    case 'REQUERIMENTO_DETALHAR_ALTERAR_LISTA_CAMPO_EXIGENCIA': {
      return {
        ...state,
        camposExigencia: action.payload
      };
    }
    case 'REQUERIMENTO_DETALHAR_SERVICO_POR_ID_ERRO':
      case 'DETALHAR_FRAGAMENTO_POR_SIGLA_ERRO':
    case 'REQUERIMENTO_DETALHAR_CAMPOS_ADICIONAIS_SERVICO_POR_ID_ERRO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), alerta: { message: action.payload, severity: 'error' } }
    case 'REQUERIMENTO_DETALHAR_DEFINIR_LISTA_CAMPO_EXIGENCIA': {
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), alerta: {}, camposExigencia: action.payload }
    }
    case 'REQUERIMENTO_DETALHAR_EXIGENCIA_INICIAR':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), esperandoExigencia: true }
    case 'REQUERIMENTO_DETALHAR_EXIGENCIA_FINALIZAR':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), esperandoExigencia: false }
    case 'REQUERIMENTO_DETALHAR_REFRESH_TAREFA':
      return { ...state, refreshTarefa: state.refreshTarefa + 1 }
    case 'DETALHAR_FRAGAMENTO_POR_SIGLA_SUCESSO':
      return { ...state, fragmento: action.payload}
    case 'SOLICITACAO_PODE_REALIZAR_ANALISE_DOCUMENTAL':
      return { ...state, tarefa: {...state.tarefa}, servico: {...state.tarefa.servico}}
    case 'PODE_REALIZAR_ANALISE_DOCUMENTAL_SUCESSO':
      return { ...state, tarefa: {...state.tarefa}, servico: {...state.tarefa.servico}, permissaoRealizarAnaliseDocumental: action.payload.permissao, esperandoSolicitacao: false}
    case 'PODE_REALIZAR_ANALISE_DOCUMENTAL_ERRO':
      return { ...state, message: action.payload}

    default:
      return state;
  }
}
